export default __webpack_public_path__ + "static/media/one-maxi.ae2b2676.jpg";